import React, { useEffect, useState } from "react";
import authenticatedFetcher from "../../services/fetcher";
import { toastError, toastSuccess } from "../../utils/ToastConfig";
import { Spinner } from "reactstrap";

export const SarMemeberSearchForm = (props) => {
  const { setSearchResult, setSelectedUser } = props;
  const [defaultAnswers, setDefaultAnswers] = useState([]);

  const [loading, setLoading] = useState(false);

  const [selectedDefaultAnswer, setSelectedDefaultAnswer] = useState();
  const [memberNumber, setMemberNumber] = useState();
  const [identityNumber, setIdentityNumber] = useState();
  const [fromDate, setFromDate] = useState();
  const [untilDate, setUntilDate] = useState();

  const handleSelectedDefaultAnswer = (event) => {
    setSelectedDefaultAnswer(event.target.value);
    setMemberNumber("");
    setIdentityNumber("");
    setFromDate("");
    setUntilDate("");
    onAnswerSearch(event.target.value);
  };
  const handleMemberNumberChange = (event) => {
    setMemberNumber(event.target.value);
    setIdentityNumber("");
    setSelectedDefaultAnswer("");
    setFromDate("");
    setUntilDate("");
  };
  const handleIdentityNumberChange = (event) => {
    setIdentityNumber(event.target.value);
    setMemberNumber("");
    setSelectedDefaultAnswer("");
    setFromDate("");
    setUntilDate("");
  };
  const handleFromDateChange = (event) => setFromDate(event.target.value);
  const handleUntilDateChange = (event) => setUntilDate(event.target.value);

  const getDefaultAnswers = () => {
    authenticatedFetcher({
      path: "/sar/default-answers/",
      urlParams: {
        nitems: 500,
      },
    }).then((response) => setDefaultAnswers(response));
  };

  const exportData = (e) => {
    e.preventDefault();
    const body = {};
    if (selectedDefaultAnswer) {
      body["default_answer"] = selectedDefaultAnswer;
    }
    if (memberNumber) {
      body["code"] = memberNumber;
    }
    if (identityNumber) {
      body["identity_document"] = identityNumber;
    }
    if (fromDate) {
      body["date_init"] = fromDate;
    }
    if (untilDate) {
      body["date_finish"] = untilDate;
    }
    if (Object.keys(body).length === 0) {
      setIdentityNumber("");
      setMemberNumber("");
      setSelectedDefaultAnswer("");
      setFromDate("");
      setUntilDate("");
      setSearchResult([]);
      setSelectedUser(undefined);
      return;
    }
    setLoading(true);
    authenticatedFetcher({
      path: "/sar/export/",
      method: "POST",
      body: body,
    })
      .then((response) =>
        toastSuccess(response.response, { autoClose: false }, true),
      )
      .finally(() => setLoading(false));
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    const body = {};
    if (selectedDefaultAnswer) {
      body["default_answer"] = selectedDefaultAnswer;
    }
    if (memberNumber) {
      body["code"] = memberNumber;
    }
    if (identityNumber) {
      body["identity_document"] = identityNumber;
    }
    if (fromDate) {
      body["date_init"] = fromDate;
    }
    if (untilDate) {
      body["date_finish"] = untilDate;
    }

    if (Object.keys(body).length === 0) {
      setIdentityNumber("");
      setMemberNumber("");
      setSelectedDefaultAnswer("");
      setFromDate("");
      setUntilDate("");
      setSearchResult([]);
      setSelectedUser(undefined);
      return;
    }
    setLoading(true);
    try {
      const response = await authenticatedFetcher({
        path: "/sar/search/",
        method: "POST",
        body: body,
      });
      if (response.length > 0) {
        setSearchResult(response);
        if (response.length === 1) {
          setSelectedUser(response[0]);
        }
        return;
      }
    } catch (error) {
      toastError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const onAnswerSearch = (answer) => {
    const body = {};
    if (answer) {
      body["default_answer"] = answer;
    }
    if (Object.keys(body).length === 0) {
      setIdentityNumber("");
      setMemberNumber("");
      setSelectedDefaultAnswer("");
      setFromDate("");
      setUntilDate("");
      setSearchResult([]);
      setSelectedUser(undefined);
      return;
    }
    setLoading(true);
    authenticatedFetcher({
      path: "/sar/search/",
      method: "POST",
      body: body,
    })
      .then((response) => {
        if (response.length > 0) {
          setSearchResult(response);
        } else {
          setSearchResult([]);
        }
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => getDefaultAnswers(), []);
  return (
    <form onSubmit={onSubmit}>
      <div className="form-row">
        <div className="col-md-4 form-group">
          <label htmlFor="respostaAutomatica">Respuesta automática:</label>
          <select
            className="form-control BasicInput"
            id="respostaAutomatica"
            value={selectedDefaultAnswer}
            onChange={handleSelectedDefaultAnswer}
            disabled={loading}
          >
            <option value=""></option>
            {defaultAnswers.map((item) => {
              return (
                <option key={item.pk} value={item.pk}>
                  {item.name}
                </option>
              );
            })}
          </select>
        </div>
        <div className="col-md-4 form-group">
          <label htmlFor="numeroMembre">Número de miembro:</label>
          <input
            type="text"
            className="form-control BasicInput"
            id="numeroMembre"
            value={memberNumber}
            onChange={handleMemberNumberChange}
            autoComplete="off"
          />
        </div>
        <div className="col-md-4 form-group">
          <label htmlFor="nif2">NIF:</label>
          <input
            type="text"
            className="form-control BasicInput"
            id="nif2"
            value={identityNumber}
            onChange={handleIdentityNumberChange}
            autoComplete="off"
          />
        </div>
      </div>
      <div className="form-row">
        <div
          className="col-md-6 form-group"
          style={{ display: "flex", alignItems: "center", gap: 10 }}
        >
          <label htmlFor="fromDate">Fecha desde:</label>
          <input
            type="date"
            className="form-control BasicInput"
            id="fromDate"
            value={fromDate}
            onChange={handleFromDateChange}
            max={untilDate}
            autoComplete="off"
          />
        </div>
        <div
          className="col-md-6 form-group"
          style={{ display: "flex", alignItems: "center", gap: 10 }}
        >
          <label htmlFor="untilDate">Hasta</label>
          <input
            type="date"
            className="form-control BasicInput"
            id="untilDate"
            value={untilDate}
            onChange={handleUntilDateChange}
            min={fromDate}
            autoComplete="off"
          />
        </div>
      </div>
      <div className="text-right">
        <button
          style={{ cursor: "pointer" }}
          type="button"
          onClick={exportData}
          className="btn btn-secondary mr-1"
          disabled={loading}
        >
          Exportar Prórrogas vigentes &#128215;
        </button>
        <button
          style={{ cursor: "pointer" }}
          type="submit"
          className="btn btn-secondary mr-1"
          disabled={loading}
        >
          Buscar &#x1F4DA;
        </button>
        {loading && <Spinner />}
      </div>
    </form>
  );
};
